import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import { getErrorMessage } from "../errors";
import {
  ClientObservationsPageable,
  ClientObservationsPageResponse,
  ClientObservationCreateData,
  IClientObservationsService,
} from "./IClientObservationsService";

export class ClientObservationsService implements IClientObservationsService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getByClientId(
    clientId: number,
    pageable: ClientObservationsPageable,
  ): Promise<ClientObservationsPageResponse> {
    try {
      const { page, size, sort } = pageable;
      const sortQuery = sort ? `&sort=${encodeURIComponent(sort)}` : "";
      return await this.httpClient.get<ClientObservationsPageResponse>(
        `/clientObservations/client/${clientId}?page=${page}&size=${size}${sortQuery}`,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar as observações do cliente. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async create(
    clientObservationData: ClientObservationCreateData,
  ): Promise<number> {
    try {
      return await this.httpClient.post<number>(
        "/clientObservations",
        clientObservationData,
        {},
        true,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível criar a observação do cliente. Confirme os dados e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await this.httpClient.delete<void>(`/clientObservations/${id}`);
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível apagar a observação do cliente. Atualize a lista e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }
}
